import React from 'react';
import { motion } from 'framer-motion';
import './index.scss';

const Loader: React.FC = () => {
  return (
    <div className="loader-container">
      <motion.div 
        className="loader"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ 
          scale: [0.5, 1, 0.5], 
          opacity: [0, 1, 0],
          rotate: [0, 180, 360]
        }}
        transition={{ 
          duration: 2, 
          repeat: Infinity, 
          ease: "easeInOut" 
        }}
      >
        <div className="loader-inner">
          <div className="loader-circle"></div>
          <div className="loader-text">加载中...</div>
        </div>
      </motion.div>
    </div>
  );
};

export default Loader;